import styles from "./notificationBell.module.scss";
import {observer} from "mobx-react-lite";
import Svg from "@components/UI/svg/svg";
import iconAnnouncements from "@source/assets/icons/iconAnnouncements.svg";
import notificationsStore from "@store/notificationsStore";

const NotificationBell = observer((props: NotificationBellProps) => {
  const {open} = props;
  const unreadCount = notificationsStore.unreadCount;

  const onClick = () => {
    if (notificationsStore.listOpen) {
      notificationsStore.closeList();
      return;
    }

    notificationsStore.openList();
  };

  const badgeLabel = unreadCount > 99 ? "99+" : `${unreadCount}`;

  return (
    <button
      type="button"
      className={`${styles.bell} ${!open ? styles.bell_collapsed : ""}`}
      onClick={onClick}
      aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"}
    >
      <span className={styles.iconWrap}>
        <Svg className={styles.icon} src={iconAnnouncements} width={24} height={24}/>
        {unreadCount > 0 ?
          <span className={styles.badge}>{badgeLabel}</span>
          :
          null}
      </span>
      {open ? <span className={styles.label}>Notifications</span> : null}
    </button>
  );
});

export default NotificationBell;

interface NotificationBellProps {
  open: boolean;
}
